import { render, staticRenderFns } from "./GeneSearch.vue?vue&type=template&id=46330c3f&scoped=true"
import script from "./GeneSearch.vue?vue&type=script&lang=js"
export * from "./GeneSearch.vue?vue&type=script&lang=js"
import style0 from "./GeneSearch.vue?vue&type=style&index=0&id=46330c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46330c3f",
  null
  
)

export default component.exports